import {Component, Input} from '@angular/core';
import {IoniconsOutline} from '@pt/pt-models';

@Component({
  selector: 'pt-warning',
  template: `
    <div class='alert warning-container gap-2' [ngClass]="alertClass" *ngIf="margin">
      <pt-icon class='d-flex' [key]='IconWarning' [size]="16" *ngIf="icon"></pt-icon>
      <label class='warning-label' *ngIf="!allowHtml">{{message | translate}}</label>
      <label class='warning-label d-inline' *ngIf="allowHtml" [innerHTML]="message | translate"></label>
    </div>

    <div class='alert warning-container gap-2 m-0' [ngClass]="alertClass" *ngIf="!margin">
      <pt-icon class='d-flex' [key]='IconWarning' [size]="16" *ngIf="icon"></pt-icon>
      <label class='warning-label' *ngIf="!allowHtml">{{message | translate}}</label>
      <label class='warning-label d-inline' *ngIf="allowHtml" [innerHTML]="message | translate"></label>
    </div>
  `,
  styles: [`
    .warning-container {
      display: flex;
      align-items: center;
      padding: 2px 10px
    }
    .warning-label {
      display: flex;
      align-items: center;
      margin: 0;
    }
  `]
})
export class WarningComponent {
  @Input() message: string;
  @Input() allowHtml: boolean;
  @Input() alertClass: 'alert-danger' | 'alert-warning' = 'alert-warning'
  @Input() margin = true;
  @Input() icon = true;
  IconWarning = IoniconsOutline.warning;
}
